export default "__VITE_PUBLIC_ASSET__f4788198__"